import { render, staticRenderFns } from "./PollList.vue?vue&type=template&id=19971c47&scoped=true"
import script from "./PollList.vue?vue&type=script&lang=js"
export * from "./PollList.vue?vue&type=script&lang=js"
import style0 from "./PollList.vue?vue&type=style&index=0&id=19971c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19971c47",
  null
  
)

export default component.exports